/**
 * BDOEX API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * Contact: mateusz.surma@mae.pl
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PaymentStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const PaymentStatus = {
    NUMBER_0: 0 as PaymentStatus,
    NUMBER_1: 1 as PaymentStatus,
    NUMBER_2: 2 as PaymentStatus,
    NUMBER_3: 3 as PaymentStatus,
    NUMBER_4: 4 as PaymentStatus,
    NUMBER_5: 5 as PaymentStatus,
    NUMBER_6: 6 as PaymentStatus
};